<template>
  <v-dialog
    v-model="isActive" persistent
    width="500" overlay-color=""
  >
    <v-card class="d-flex justify-center align-center flex-column pa-10">
      <v-card-text class="text-center text-h6 font-weight-bold black--text">
        <div style="white-space: pre-line">
          {{ message }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn class="button save px-10" outlined @click="callBack">확인</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default  {
  name: "Alert",
  props: ["isActive"],
  computed: {
    ...mapGetters("alert", {
      message: "message",
      successCallback: "successCallback"
    })
  },
  created() {
    window.addEventListener("keydown", this.callBack);
  },
  destroyed() {
    window.removeEventListener("keydown", this.callBack);
  },
  methods: {
    ...mapActions("alert", ["initData"]),
    callBack() {
      this.successCallback();
      this.initData();
    }
  }
}
</script>